export default __webpack_public_path__ + "images/GCS.76b5576.png";